

export function overrideOrbitControls(viewer) {

    // console.log("OrbitControls override is being applied..");
    const OriginalOrbitControls = Potree.OrbitControls;


    // Extend the existing OrbitControls class
    class CustomOrbitControls extends OriginalOrbitControls {
        constructor(viewer) {
            super(viewer);

            this.keyboardPanSpeed = 10; // Ensure this value matches your desired speed

            // Remove existing keyboard listeners to avoid duplicates/conflicts
            // window.removeEventListener("keydown", this.keyboardListener);
            // window.removeEventListener("keyup", this.keyboardListener);

            // Add custom key listeners
            this.keysPressed = {
                ArrowUp: false,
                ArrowDown: false,
                ArrowLeft: false,
                ArrowRight: false,
            };
            this.initializeKeyListeners();
        }

        initializeKeyListeners() {
            window.addEventListener("keydown", (e) => {
                // console.log(e.key);
                if (e.key in this.keysPressed) {
                    this.keysPressed[e.key] = true;
                    e.preventDefault();
                }

                if (e.key >= "1" && e.key <= "9") {
                    this.keyboardPanSpeed = parseInt(e.key) * 20; // Set speed (10, 20, ..., 90)
                    // console.log(`Keyboard pan speed set to ${this.keyboardPanSpeed}`);
                }

            });

            window.addEventListener("keyup", (e) => {
                if (e.key in this.keysPressed) {
                    this.keysPressed[e.key] = false;
                    e.preventDefault();
                }
            });


        }

        // Override the update method to include custom translation logic
        update(delta) {
            super.update(delta); // Call the original logic
            // Add custom key-based translation logic
            const view = this.scene.view;

            let keyPanX = 0;
            let keyPanY = 0;

            // Adjust based on pressed keys
            if (this.keysPressed.ArrowUp) keyPanY += 1;
            if (this.keysPressed.ArrowDown) keyPanY -= 1;
            if (this.keysPressed.ArrowLeft) keyPanX -= 1;
            if (this.keysPressed.ArrowRight) keyPanX += 1;

            // Normalize diagonal movement
            const len = Math.sqrt(keyPanX * keyPanX + keyPanY * keyPanY);
            if (len > 0) {
                keyPanX /= len;
                keyPanY /= len;
            }

            // Scale translation by pan speed and delta for frame independence
            const px = keyPanX * this.keyboardPanSpeed * delta;
            const py = keyPanY * this.keyboardPanSpeed * delta;

            // Apply translation
            // console.log(px, py);
            view.pan(px, py);
        }
    }

    // Replace the original OrbitControls with the custom one
    // Potree.OrbitControls = CustomOrbitControls;
    // This doesn't quite work
    // Instead, we just replace the one in the viewer instance
    viewer.orbitControls = new CustomOrbitControls(viewer);
    // If we wanted to manually set controls to our new viewer:
    // viewer.setControls(new CustomOrbitControls(viewer));
}
